(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/draws-redux/assets/javascripts/hooks/use-related-draw.js') >= 0) return;  svs.modules.push('/components/sport/draws-redux/assets/javascripts/hooks/use-related-draw.js');
"use strict";


const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const loadDrawsLite = svs.components.sport.drawsRedux.actions.loadDrawsLite;
const _React = React,
  useEffect = _React.useEffect;
const makeSelectRelatedDraw = svs.components.sport.drawsRedux.selectors.makeSelectRelatedDraw;
const useMemoizedSelector = svs.components.lbUtils.hooks.useMemoizedSelector;
const relatedTypes = svs.components.sport.drawsRedux.constants.relatedTypes;
const useRelatedDraw = function (_ref) {
  let productId = _ref.productId,
    relatedProductId = _ref.relatedProductId,
    drawNumber = _ref.drawNumber,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? relatedTypes.PIX : _ref$type;
  let _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$skip = _ref2.skip,
    skip = _ref2$skip === void 0 ? false : _ref2$skip;
  const dispatch = useDispatch();
  const selectRelatedDraws = useMemoizedSelector(makeSelectRelatedDraw, productId, drawNumber, type);
  const relatedDraw = useSelector(state => selectRelatedDraws(state));
  useEffect(() => {
    if (!productId || skip) {
      return;
    }
    if (!relatedDraw || relatedDraw.length === 0) {
      dispatch(loadDrawsLite({
        relatedProductId,
        productId,
        drawNumber,
        type
      }));
    }
  }, [productId, relatedDraw, dispatch, skip, relatedProductId, drawNumber, type]);
  return relatedDraw;
};
setGlobal('svs.components.sport.drawsRedux.hooks.useRelatedDraw', useRelatedDraw);

 })(window);